/*
 * Parses an app URL for both topic lectures and learnpath lectures depending on
 * the prefix used in the path, returning a react-router-style `{ params }`
 * object (or null for an unrecognized prefix). Implemented without
 * react-router's `matchPath` so the app can drop the react-router-dom
 * dependency — the lecture-family URLs have fixed positional segments.
 */
const PATTERNS = [
  // /learnpaths/:learnpathId/:elementId/:topic?/:lecture?
  {
    prefix: 'learnpaths',
    params: ['learnpathId', 'elementId', 'topic', 'lecture'],
    required: 2,
  },
  // /lectures/:topic/:lecture
  { prefix: 'lectures', params: ['topic', 'lecture'], required: 2 },
  // /skill/:skill/:topic/:lecture
  { prefix: 'skill', params: ['skill', 'topic', 'lecture'], required: 3 },
  // /course-generic/:course/:topic/:lecture
  {
    prefix: 'course-generic',
    params: ['course', 'topic', 'lecture'],
    required: 3,
  },
] as const

export const parseLectureLink = (
  path: string,
): { params: Record<string, string> } | null => {
  const [prefix, ...rest] = (path ?? '').split('/').filter(Boolean)
  const pattern = PATTERNS.find((p) => p.prefix === prefix)

  if (!pattern || rest.length < pattern.required) {
    return null
  }

  const params: Record<string, string> = { prefix }
  pattern.params.forEach((name, index) => {
    if (rest[index] !== undefined) {
      params[name] = rest[index]
    }
  })

  return { params }
}

export default parseLectureLink
